import { render, staticRenderFns } from "./LifeCard.vue?vue&type=template&id=db305cb4"
import script from "./LifeCard.vue?vue&type=script&lang=js"
export * from "./LifeCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports